export function getSafeFunction(func) {
  return (callback, ...params) => {
    return func(...params, callback).catch(error => {
      return callback && callback(error);
    });
  };
}
